import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import Immutable from 'immutable';
import BillingEditButton from './BillingEditButton';
import PrintBillingButton from './PrintBillingButton';
import { BILL_PROCESS_STATUS_PROCESSED } from '../../../../config/constants';
import BillReversionButton from '../bill-report-retention-reversion/BillReversionButton';

const BillingToolbar = ({
  billingId,
  ticket,
  status,
  processType,
  billing,
}) => {
  const NOT_EDITABLE_PROCESS_TYPES = ['NOTA_CREDITO', 'RETENCION', 'REVERSION'];

  const canEdit =
    status !== BILL_PROCESS_STATUS_PROCESSED &&
    !NOT_EDITABLE_PROCESS_TYPES.includes(processType);

  const isRetention = processType === 'RETENCION';

  return (
    <ButtonToolbar className="pull-right">
      <div>
        {canEdit && <BillingEditButton billingId={billingId} />}{' '}
        {ticket && <PrintBillingButton ticket={ticket} />}
        {isRetention && <BillReversionButton billing={billing} />}
      </div>
    </ButtonToolbar>
  );
};

BillingToolbar.propTypes = {
  billingId: PropTypes.number.isRequired,
  ticket: PropTypes.string,
  status: PropTypes.string.isRequired,
  processType: PropTypes.string.isRequired,
  billing: PropTypes.instanceOf(Immutable.Map).isRequired,
};

BillingToolbar.defaultProps = {
  ticket: null,
};

export default BillingToolbar;
